import NumberStr from './number-str';
import Vue from 'vue';
import { env } from "@/env"

function toNumber(value) {
    if (typeof value == 'number') {
        return value;
    }
    if (isSymbol(value)) {
        return NAN;
    }
    if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? (other + '') : other;
    }
    if (typeof value != 'string') {
        return value === 0 ? value : +value;
    }
    value = value.replace(reTrim, '');
    var isBinary = reIsBinary.test(value);
    return (isBinary || reIsOctal.test(value)) ?
        freeParseInt(value.slice(2), isBinary ? 2 : 8) :
        (reIsBadHex.test(value) ? NAN : +value);
}

function now() {
    return new Date();
}

function isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}

/**
 * @desc  获取页面类型
 * 首页：index，频道首页：channel，二级页：sub，标签页：tag，文章页：article
 */
function getPageType () {
    var path = window.location.pathname.split('/')[1];
    var pageType;
    switch (path) {
        case 'ch':
            pageType = 'channel';
            break;
        case 'a':
            pageType = 'article';
            break;
        case 'sa':
            pageType = 'article';
            break;
        case 'o':
            pageType = 'article';
            break;
        case 'subject':
            pageType = 'subject';
            break;
        case 'v':
            pageType = 'video';
            break;
        case '':
            pageType = 'index';
            break;
            break;
        default:
            pageType = '';
    }
    return pageType;
}
var Util = {
    // 将http开头的协议换成相对协议
    transferToRelativeProtocol: function(baseUrl) {
        return baseUrl.replace(/^http:\/\//, '//');
    },
    mixObjByTemplate(tplObj, item) {
        var objToStrFunc = Object.prototype.toString;
        var ObjStr = '[object Object]';
        var res = {};
        if ((tplObj && objToStrFunc.call(tplObj) === ObjStr) && (item && objToStrFunc.call(item) === ObjStr)) {
            for (var i in tplObj) {
                if (tplObj.hasOwnProperty(i)) {
                    if (typeof item[i] === 'number') {
                        res[i] = item[i];
                    } else {
                        res[i] = item[i] || tplObj[i];
                    }
                }
            }
        }
        return res;
    },
    isEmpty: function(obj) {
        if (obj.replace(/(^\s*)|(\s*$)/g, '').length <= 0) { //null
            return true;
        } else { // not null
            return false;
        }
    },
    checkMobile: function(obj) {
        if (this.isEmpty(obj) || (!/^1([3-9][0-9]{9})$/.test(obj))) { //格式不正确
            return false;
        } else { // 格式正确
            return true;
        }
    },
    /**
     * [addQueryArgs 给url添加参数]
     * @param {[string]} url      [需添加参数的url]
     * @param {[object]} paramObj [需添加的参数,hash键值对形式]
     */
    addQueryArgs: function(url, paramObj) {
        var result;
        var key, value;

        for (key in paramObj) {
            value = paramObj[key];
            result = new RegExp("(" + key + "=)[^&]+", "i");
            if (url.match(result)) {
                url = url.replace(result, "$1" + value);
            } else {
                url += (url.indexOf('?') === -1) ?
                    ('?' + key + '=' + value) : ('&' + key + '=' + value);
            }
        }

        return url;
    },
    /**
     * [removeQueryArgs 删除url中的参数]
     * @param {[string]} url      [需删除参数的url]
     * @param {[array]} paramArr  [需删除的参数列表]
     */
    removeQueryArgs: function(url, paramArr) {
        var result;
        var len = paramArr.length;

        for (var i = 0; i < len; i++) {
            result = new RegExp("(" + paramArr[i] + "=[^&]+)", "i");
            if (url.match(result)) {
                url = url.replace(result, '');
            }
        }

        return url;
    },
    parseURL(_url) {
        let url = decodeURIComponent(_url);
        let paramStr = url.split('?')[1];
        if (!paramStr) {
            return {};
        }
        let args = {};
        let items = paramStr.split('&');

        let item = null,
            name = null,
            value = null;
        for (let i = 0; i < items.length; i++) {
            item = items[i].split("=");
            if (item[0]) {
                name = item[0];
                value = item[1] ? item[1] : "";
                args[name] = value;
            }
        }
        return args;
    },
    debounce: function(func, wait, options) {
        var lastArgs,
            lastThis,
            maxWait,
            result,
            timerId,
            lastCallTime,
            lastInvokeTime = 0,
            leading = false,
            maxing = false,
            trailing = true;

        if (typeof func != 'function') {
            throw new TypeError("fun error");
        }
        wait = toNumber(wait) || 0;
        if (isObject(options)) {
            leading = !!options.leading;
            maxing = 'maxWait' in options;
            maxWait = maxing ? Math.max(toNumber(options.maxWait) || 0, wait) : maxWait;
            trailing = 'trailing' in options ? !!options.trailing : trailing;
        }

        function invokeFunc(time) {
            var args = lastArgs,
                thisArg = lastThis;

            lastArgs = lastThis = undefined;
            lastInvokeTime = time;
            result = func.apply(thisArg, args);
            return result;
        }

        function leadingEdge(time) {
            // Reset any `maxWait` timer.
            lastInvokeTime = time;
            // Start the timer for the trailing edge.
            timerId = setTimeout(timerExpired, wait);
            // Invoke the leading edge.
            return leading ? invokeFunc(time) : result;
        }

        function remainingWait(time) {
            var timeSinceLastCall = time - lastCallTime,
                timeSinceLastInvoke = time - lastInvokeTime,
                result = wait - timeSinceLastCall;

            return maxing ? Math.min(result, maxWait - timeSinceLastInvoke) : result;
        }

        function shouldInvoke(time) {
            var timeSinceLastCall = time - lastCallTime,
                timeSinceLastInvoke = time - lastInvokeTime;

            // Either this is the first call, activity has stopped and we're at the
            // trailing edge, the system time has gone backwards and we're treating
            // it as the trailing edge, or we've hit the `maxWait` limit.
            return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
                (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
        }

        function timerExpired() {
            var time = now();
            if (shouldInvoke(time)) {
                return trailingEdge(time);
            }
            // Restart the timer.
            timerId = setTimeout(timerExpired, remainingWait(time));
        }

        function trailingEdge(time) {
            timerId = undefined;

            // Only invoke if we have `lastArgs` which means `func` has been
            // debounced at least once.
            if (trailing && lastArgs) {
                return invokeFunc(time);
            }
            lastArgs = lastThis = undefined;
            return result;
        }

        function cancel() {
            if (timerId !== undefined) {
                clearTimeout(timerId);
            }
            lastInvokeTime = 0;
            lastArgs = lastCallTime = lastThis = timerId = undefined;
        }

        function flush() {
            return timerId === undefined ? result : trailingEdge(now());
        }

        function debounced() {
            var time = now(),
                isInvoking = shouldInvoke(time);

            lastArgs = arguments;
            lastThis = this;
            lastCallTime = time;

            if (isInvoking) {
                if (timerId === undefined) {
                    return leadingEdge(lastCallTime);
                }
                if (maxing) {
                    // Handle invocations in a tight loop.
                    timerId = setTimeout(timerExpired, wait);
                    return invokeFunc(lastCallTime);
                }
            }
            if (timerId === undefined) {
                timerId = setTimeout(timerExpired, wait);
            }
            return result;
        }
        debounced.cancel = cancel;
        debounced.flush = flush;
        return debounced;
    },
    throttle: function(func, wait, options) {
        var leading = true,
            trailing = true;

        if (typeof func != 'function') {
            throw new TypeError("fun error");
        }
        if (isObject(options)) {
            leading = 'leading' in options ? !!options.leading : leading;
            trailing = 'trailing' in options ? !!options.trailing : trailing;
        }
        return Util.debounce(func, wait, {
            'leading': leading,
            'maxWait': wait,
            'trailing': trailing
        });
    },
    // 数组字符串转数组
    arrayStrToArray: function(str) {
        if (typeof str != 'string') {
            return
        }
        return JSON.parse(str);
    },
    // 解决滚动穿透的2个工具方法
    fixedBody: function() {
        var scrollTop = document.body.scrollTop || document.documentElement.scrollTop;
        document.body.style.cssText += 'position:fixed;width:100%;height:100%;top:-' + scrollTop + 'px;';
    },
    looseBody: function() {
        var body = document.body;
        body.style.position = '';
        body.style.width = 'auto';
        body.style.height = 'auto';
        var top = body.style.top;
        document.body.scrollTop = document.documentElement.scrollTop = -parseInt(top);
        body.style.top = '';
    },
    /*
    ** @desc  获取pvId
    ** @return {string}
    */
    getPvId () {
        let spmCode
        let pvId = 0;
        if(window.sohuSpm && typeof window.sohuSpm.getCodes === 'function') {
            spmCode = window.sohuSpm.getCodes();
            pvId = spmCode.e;
        }
        return pvId
    },
    /*
    ** @desc  获取spmcode
    ** @return object
    */
    getSpmCode () {
        let spmCode = {}
        if(window.sohuSpm && typeof window.sohuSpm.getCodes === 'function') {
            spmCode = window.sohuSpm.getCodes();
        }
        return spmCode
    },

    getSpmContent (data) {
        let _spmAttrArr = ['resourceType', 'authorId', 'id', 'pcm', 'type', 'etc']
        let _spmConArr = []
        for (let attr in _spmAttrArr) _spmConArr.push(data[_spmAttrArr[attr]] ? data[_spmAttrArr[attr]] : '')
        return _spmConArr.join('|')
    },

    /**
    * @desc  获取频道id
    */
    getChannelId () {
        var channelId = '';
        var pageType = getPageType();
        // 频道首页从url中获取频道id
        if (pageType === 'channel' || pageType === 'subject' || pageType === 'video') {
            channelId = window.location.pathname.split('/')[2];
            // 文章页从后端输出的变量中获取
        } else if (pageType === 'article') {
            channelId = window.pcArticleInfo && window.pcArticleInfo.channelId;
        } else if (pageType === 'index') {
            channelId = 0;
        }
        return channelId;
    },
    /**
     * @desc  判断是否是测试环境（用于的环境判断）
     */
    isTestEnvironment: function() {
        // 正式环境：t3.m.sohu.com/m.sohu.com/m.sohu
        var isTest =  !(/^(t3\.m|n\.m|feed\.m|m)\.sohu(\.com)?/.test(window.location.host));
        if(window.deployEnv == 'test') isTest = true;
        return isTest;
    },
    /**
     * @description 获取SSP请求主机名
     */
    getSSPHost: function() {
        let _hostMap = {
            "test": "//d1.m.sohu.com",
            "pre": "//ssp-pre.aty.sohu.com",
            "prod": "//v2.sohu.com",
        }

        return _hostMap[env]
    },
    /**
     * @desc 全局的eventBus，用于组件间通信
     */
    eventBus: new Vue(),

    /**
     * @description 调用打码SDK的domDidChange方法
     * @param  {...any} args 参数列表
     */
    domDidChange: function(...args){
        if(window.sohuSpm && typeof window.sohuSpm.domDidChange === 'function'){
            window.sohuSpm.domDidChange(...args)
        }
    },
    setCount (count) {
        let num = '';
        if (999 > count > 0) {
            num = count
        } else if (count > 999) {
            num = `999+`
        }
        return num;
    },
    queryString() {
        let obj = {}
        let query = window.location.search.substring(1)
        let lets = query.split('&')
        for (let i = 0; i < lets.length; i++) {
          let pair = lets[i].split('=')
          // If first entry with this name
          if (typeof obj[pair[0]] === 'undefined') {
            obj[pair[0]] = decodeURIComponent(pair[1])
            // If second entry with this name
          } else if (typeof obj[pair[0]] === 'string') {
            let arr = [obj[pair[0]], decodeURIComponent(pair[1])]
            obj[pair[0]] = arr
            // If third or later entry with this name
          } else {
            obj[pair[0]].push(decodeURIComponent(pair[1]))
          }
        }
        return obj
    },
    queryStringByUrl(url = '') {
        let obj = {}
        let query = url.split('?').length > 1 ? url.split('?')[1] : ''
        let lets = query.split('&')
        for (let i = 0; i < lets.length; i++) {
          let pair = lets[i].split('=')
          // If first entry with this name
          if (typeof obj[pair[0]] === 'undefined') {
            obj[pair[0]] = decodeURIComponent(pair[1])
            // If second entry with this name
          } else if (typeof obj[pair[0]] === 'string') {
            let arr = [obj[pair[0]], decodeURIComponent(pair[1])]
            obj[pair[0]] = arr
            // If third or later entry with this name
          } else {
            obj[pair[0]].push(decodeURIComponent(pair[1]))
          }
        }
        return obj
      },
    parseUrl(url) {
    var result = {}
    var keys = [
      'href',
      'origin',
      'protocol',
      'host',
      'hostname',
      'port',
      'pathname',
      'search',
      'hash',
    ]
    var i
    var regexp = /(([^:]+:)\/\/(([^:\/\?#]+)(:\d+)?))(\/[^?#]*)?(\?[^#]*)?(#.*)?/

    var match = regexp.exec(url)

    if (match) {
      for (i = keys.length - 1; i >= 0; --i) {
        result[keys[i]] = match[i] ? match[i] : ''
      }
    }
    return result
  },
  jsonp(url, data={}) {
    return new Promise((resolve, reject) => {
        window.__fn__ = data => resolve(data)
        let script = document.createElement('script')
        let query = Object.entries(data).map(a=>`${a[0]}=${a[1]}`).join('&')
        script.src = url + '?callback=__fn__&' + query
        script.onerror = () => reject('加载失败')
        document.head.appendChild(script)
        document.head.removeChild(script)
    })
  }
};
export default Util;